import React from "react";
import type { ComponentProps } from "react";
import cx from "classnames";
import { Pill, ShieldTickIcon } from "@picklebet/ui";

import * as styles from "@/features/betslip/components/parts/tokens/PromoPills.module.scss";

type ConditionalPillProps = Omit<
  ComponentProps<typeof Pill>,
  "className" | "overrideSvgFill" | "onMouseDown"
>;

export const ConditionalPill = ({
  children,
  ...props
}: ConditionalPillProps) => (
  <Pill
    className={cx(styles.tokenPill, styles.conditional)}
    overrideSvgFill={false}
    onMouseDown={(e) => e.preventDefault()}
    {...props}
  >
    <span className={styles.icon}>
      <ShieldTickIcon />
    </span>
    {children}
  </Pill>
);
